import React from "react";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  canonicalUrl?: string;
  noindex?: boolean;
  nofollow?: boolean;
}

export function SEO({
  title,
  description,
  keywords = "study abroad, migration services, flight booking, international education, visa services, overseas study, student visa, work permit, travel tickets",
  ogTitle,
  ogDescription,
  ogImage = "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&q=80",
  canonicalUrl,
  noindex = false,
  nofollow = false,
}: SEOProps) {
  const fullTitle = `${title} | BeginPack Ltd`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
      <meta
        name="robots"
        content={`${noindex ? "noindex" : "index"},${
          nofollow ? "nofollow" : "follow"
        }`}
      />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </>
  );
}

export default SEO;
